import React, { useContext, createContext } from 'react';
import { Classroom } from '@teetsh/app/src/types/classroom';

const ClassroomContext = createContext<Classroom | undefined>(undefined);

interface Props {
  classroom: Classroom;
  children: React.ReactNode;
}

function ClassroomProvider(props: Props) {
  return <ClassroomContext.Provider value={props.classroom} {...props} />;
}

function useClassroom() {
  const context = useContext(ClassroomContext);
  if (context === undefined) {
    throw new Error('useClassroom must be used within a ClassroomProvider');
  }
  return context;
}

export { ClassroomProvider, useClassroom };
